import { FaChartBar, FaUsers } from 'react-icons/fa';
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import GeneralResultsWrapper from './GeneralResults';
import ServicesWrapper from '../Common/Services/page';
import { QUERY_KEYS_SIH } from '../../Common/hooks/useChartsData';
import { subtitlesMap } from '../Common/maps/subtitleMap';
import ChartsContainer from '../../Common/ChartsContainer';

const menus = [
    {
        title: 'Resultados Gerais',
        path: '/governanceroom/dashboardsihsus/aih/general-results',
        icon: <FaChartBar className="icon" />
    },
    {
        title: 'Especialidades',
        path: '/governanceroom/dashboardsihsus/aih/specialities',
        icon: <FaUsers className="icon" />
    }
];

const titleMap = {
    '/governanceroom/dashboardsihsus/aih/general-results':
        'Autorização de Internação Hospitalar - Total',
    '/governanceroom/dashboardsihsus/aih/specialities': 'AIH - Especialidades'
};

export const AIH = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardsihsus');
    };

    return (
        <div className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <div>
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="general-results"
                            element={<GeneralResultsWrapper />}
                        />
                        <Route
                            path="specialities"
                            element={
                                <ServicesWrapper
                                    module={{
                                        sectionTitle:
                                            'das AIH por Especialidade'
                                    }}
                                    queryConfig={{
                                        key: QUERY_KEYS_SIH.SPECIALITIES_AIH,
                                        url: 'governanceroom/dashboard/sihsus/aih/specialties'
                                    }}
                                    subtitlesMap={subtitlesMap}
                                />
                            }
                        />

                        <Route
                            path="/"
                            element={<Navigate to="general-results" replace />}
                        />
                    </Routes>
                </ChartsContainer>
            </div>
        </div>
    );
};
